'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_user$package$AccountId$() {
  this.s2 = 0;
  this.s3 = 0;
  $n_Lmealorama_user$package$AccountId$ = this;
  $m_Lmealorama_user$package$AccountId$();
  this.s2 = 0;
  this.s3 = 0;
}
export { $c_Lmealorama_user$package$AccountId$ as $c_Lmealorama_user$package$AccountId$ };
$p = $c_Lmealorama_user$package$AccountId$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_user$package$AccountId$;
/** @constructor */
function $h_Lmealorama_user$package$AccountId$() {
}
export { $h_Lmealorama_user$package$AccountId$ as $h_Lmealorama_user$package$AccountId$ };
$h_Lmealorama_user$package$AccountId$.prototype = $p;
var $d_Lmealorama_user$package$AccountId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_user$package$AccountId$, "mealorama.user$package$AccountId$", ({
  LX: 1
}));
export { $d_Lmealorama_user$package$AccountId$ as $d_Lmealorama_user$package$AccountId$ };
var $n_Lmealorama_user$package$AccountId$;
function $m_Lmealorama_user$package$AccountId$() {
  if ((!$n_Lmealorama_user$package$AccountId$)) {
    $n_Lmealorama_user$package$AccountId$ = new $c_Lmealorama_user$package$AccountId$();
  }
  return $n_Lmealorama_user$package$AccountId$;
}
export { $m_Lmealorama_user$package$AccountId$ as $m_Lmealorama_user$package$AccountId$ };
//# sourceMappingURL=mealorama.user$package$-Account-Id$.js.map
